import gql from 'graphql-tag'

export default gql`
    mutation createRelease($name: String!, $repos: String!) {
        createRelease(Name: $name, Repos: $repos)
    }
`
